const toggleDownloadButton = () => {
  const btnGoogle = document.querySelector('.btn-google')
  const btnGoogleParent = btnGoogle !== null ? btnGoogle.parentElement : null
  const btnApple = document.querySelector('.btn-apple')
  const btnAppleParent = btnApple !== null ? btnApple.parentElement : null
  const downloadAppGoogle = document.querySelector('#download-app-google')
  const downloadAppApple = document.querySelector('#download-app-apple')
  const isAppleProduct = /Macintosh|iPhone|iPad|iPod/i.test(navigator.userAgent)

  if (btnGoogleParent !== null || btnAppleParent !== null) {
    if (isAppleProduct) {
      btnGoogleParent.style.display = 'none'
    } else {
      btnAppleParent.style.display = 'none'
    }
  }

  if (downloadAppGoogle !== null || downloadAppApple !== null) {
    if (isAppleProduct) {
      downloadAppGoogle.style.display = 'none'
    } else {
      downloadAppApple.style.display = 'none'
    }
  }
}

function init() {
  toggleDownloadButton()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/toggleDownloadButton.js